export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/00_TV frame new_box/framenew_box${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/pluto.png'),
  designImageList: [
    {
      number: 1,
      side: 'SIDE',
      image: require('../../../parts/pluto/01.png'),
    },
    {
      number: 2,
      text: '(2)~(5)',
      side: 'FACE',
      image: require('../../../parts/pluto/02.png'),
    },
    {
      number: 6,
      side: 'FACE',
      image: require('../../../parts/pluto/03.png'),
    },
    {
      number: 7,
      text: '(7)~(9)',
      side: 'MIDDLE',
      image: require('../../../parts/pluto/04.png'),
    },
    {
      number: 10,
      text: "(10)~(12)",
      side: 'MIDDLE',
      image: require('../../../parts/pluto/05.png'),
    },
    {
      number: 13,
      text: "(13)~(15)",
      side: 'LEG',
      image: require('../../../parts/pluto/06.png'),
    },
    {
      number: 16,
      text:"(16)~(17)",
      side: 'LEG',
      image: require('../../../parts/pluto/07.png'),
    },
    {
      number: 18,
      side: 'LEG',
      image: require('../../../parts/pluto/08.png'),
    },
    {
      number: 19,
      side: 'LEG',
      image: require('../../../parts/pluto/09.png'),
    },
    {
      number: 20,
      text: "(20)~(21)",
      side: 'JOINT',
      image: require('../../../parts/pluto/10.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/pluto/11.png'),
  assembleSequenceImages: Array(171)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/45_pluto/pluto${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/Pluto.jpg'),
  completeImagePc: require('../../../complete/Pluto.jpg'),
};
